// const AdminConfig = 'http://development.delasoft.com:8443/UPA-adminconfig'
// const Admin = 'http://development.delasoft.com:8443/UPA-admin'

import { getEnvVariable } from "../../../modules/environmentalList"

const InvoiceCycleEdit = {
    "type": "popup",
    "key": "InvoiceCycleEdit",
    "name": "InvoiceCycleEdit",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'editOpen'
    },
    sharedValues: ['open'],
    container: {
        closepopup: true,
        closepopupval: 'invoicecycles',
        "addRoute": true,
        "routeParams": { replace: 'invoicecycles', param: 'Id', routeName: 'id' },
        'removelayout': 'InvoiceCycleEdit',
        values: { editInfo: null, edit: false, createduplicate: false, fullscreen: false, back: false, allgriddata: null, navigation: null },
        mapValues: {
            header: [
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
                { key: 'allgriddata', name: 'allgriddata' },
            ],
            InvoiceCycle: [
                { key: 'editInfo', name: 'editInfo' },
                { key: 'allgriddata', name: 'allgriddata' },
                { key: 'save', name: 'save' },
                { key: 'saveduplicate', name: 'saveduplicate' },
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
                { key: 'back', name: 'back' },
                { key: 'navigation', name: 'navigation' },]
        },
        //  sharedValues: ['save', 'edit'],
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: '',
                style: { marginLeft: '4px', marginRight: '4px' },
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },


            {
                order: 1,
                type: 'div',
                className: 'row m-1 application-border',
                components: [{
                    name: 'InvoiceCycle',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },
            ]
        },

        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'Invoice Cycle',
                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "Invoice Cycle", "materialicon": "attach_money", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                        title: 'Back'
                    },

                    {
                        type: 'icon',
                        icon: 'edit',
                        name: 'edit',
                        hideon: 'createduplicate',
                        hideanother: 'edit',
                        hidevalue: true,
                        title: 'Edit'
                    },
                    // {
                    //     type: 'icon',
                    //     icon: 'duplicate',
                    //     name: 'createduplicate',
                    //     hideon: 'edit',
                    //     hideanother: 'createduplicate',
                    //     hidevalue: true,
                    //     title: 'Clone'
                    // },
                    {
                        type: 'icon',
                        icon: 'save',
                        color:'green',
                        name: 'save',
                        hideon: 'edit',
                        hidevalue: false,
                        title: 'Save'
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        color:'green',
                        name: 'saveduplicate',
                        hideon: 'createduplicate',
                        hidevalue: false,
                        title: 'Save'
                    },
                    {
                        type: 'icon',
                        icon: 'previtem',
                        name: 'previtem',
                        hideon: 'previtem',
                        hidevalue: false,
                        title: 'Previous Item'
                    },
                    {
                        type: 'icon',
                        icon: 'nextitem',
                        name: 'nextitem',
                        hideon: 'nextitem',
                        hidevalue: false,
                        title: 'Next Item'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hidevalue: false,
                        title: 'Full Screen'
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false,
                        title: 'Exit Full Screen'
                    },
                    {
                        type: 'icon',
                        icon: 'history',
                        name: 'history',
                        title: 'History',
                        hideon: 'history',
                        hidevalue: false,
                        historyurl: {
                            title : 'InvoiceCyclesHistory',
                            url: getEnvVariable('Admin') + `/api/InvoiceCycle/history/{Id}?`,
                            "routeProps": [{ name: "Id", key: "Id", },],
                            type: 'get',
                            saveAs: { key: 'data' }
                        }
                    },
                ],


            },
            InvoiceCycle: {
                "type": "form",
                initRun: true,
                "key": "InvoiceCycle",
                "name": "InvoiceCycle",
                aliases: {
                    'editInfo': 'editInfo',
                    'allgriddata': 'allgriddata',
                    'navigateItem': 'navigateItem',	
                    'edit': 'edit'
                },
                sharedValues: ['editInfo', 'allgriddata',  'navigateItem', 'navigation', 'edit', 'save', 'createduplicate', 'exitfullscreen', 'fullscreen', 'back', 'saveduplicate'],
                validationMapKeys: [],
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Name',
                                type: 'div',
                                className: 'col-10 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 mt-2',
                                }
                            }],

                        },

                        {
                            order: 1,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Description',
                                type: 'div',
                                className: 'col-10 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 mt-2',
                                }
                            }
                            ]
                        },
                        {
                            order: 2,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'IsInvoiced',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },
                                {
                                    name: 'InvoicePeriod',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },


                            ]
                        },
                        {
                            order: 3,
                            type: 'div',
                            className: 'row',
                            components: [
                            {
                                name: 'InvoiceType',
                                type: 'div',
                                className: 'col-5 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                }
                            },
                            {
                                name: 'InvoiceOn',
                                type: 'div',
                                className: 'col-5 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                }
                            }
                        ]
                        },
                        {
                            order: 4,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'GenerateInvoiceOn',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },
                                {
                                    name: 'GenerateInvoiceDate',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                }
                            ]
                        },
                        {
                            order: 5,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'DateOnInvoice',
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 pl-4 ml-3 mt-3',
                                    }
                                },
                                {
                                    name: 'DateToPrintOnInvoice',
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 pl-4 ml-3 mt-3',
                                    }
                                }
                            ]
                        },
                        {
                            order: 6,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'PaymentDueOnInvoice',
                                    type: 'div',
                                    className: 'col-10 pl-4 ml-3 mt-3',
                                    sub: {
                                        type: 'div',
                                        className: 'col-10 pl-4 ml-3 mt-3',
                                    }
                                }
                            ]
                        },
                        {
                            order: 7,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'PaymentDueDays',
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 pl-4 ml-3 mt-3',
                                    }
                                },
                                {
                                    name: 'PaymentDueDate',
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 pl-4 ml-3 mt-3',
                                    }
                                }
                            ]
                        },
                        {
                            order: 8,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Status',
                                type: 'div',
                                className: 'col-10 pl-4 ml-3 mt-3',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 pl-4 ml-3 mt-3',
                                }
                            }]
                        },
                        {
                            order: 9,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'CreatedOn',
                                type: 'div',
                                className: 'col-5 pl-4 ml-3 mt-3',
                                sub: {
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                }
                            },
                            {
                                name: 'CreatedByName',
                                type: 'div',
                                className: 'col-5 pl-4 ml-3 mt-3',
                                sub: {
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                }
                            },
                            ]
                        },
                        {
                            order: 10,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'UpdatedOn',
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 pl-4 ml-3 mt-3',
                                    }
                                },
                                {
                                    name: 'UpdatedByName',
                                    type: 'div',
                                    className: 'col-5 pl-4 ml-3 mt-3',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 pl-4 ml-3 mt-3',
                                    }
                                },]
                        },

                    ],
                },
                values: {
                    Name: '',
                    Description: '',
                    IsInvoiced:'',
                    InvoicePeriod:'',
                    InvoiceType: '',
                    InvoiceOn: '',
                    GenerateInvoiceOn: '',
                    DateOnInvoice: '',
                    PaymentDueOnInvoice: '',
                    GenerateInvoiceDate: '',
                    DateToPrintOnInvoice:'',
                    PaymentDueDate:'',
                    PaymentDueDays:'',
                    UpdatedByName: '',
                    CreatedByName: '',
                    UpdatedOn: '',
                    CreatedOn: '',
                    UpdatedBy: '',
                    CreatedBy: '',
                    Id: '',
                    Status:'',
                    editInfo: null,
                    allgriddata: null,
                    navigation: null
                },

                "components": {
                    Name: {
                        "type": "label",
                        "key": "Name",
                        "label": "Name",
                        "name": "Name",
                        changefieldto: "textfield",
                    },
                    Description: {
                        "type": "label",
                        "key": "Description",
                        "label": "Description",
                        "name": "Description",
                        changefieldto: "textfield",
                    },
                    IsInvoiced: {
                        "type": "label",
                        "key": "IsInvoiced",
                        "name": "IsInvoiced",
                        "label": "Is Invoiced",
                        changefieldto: "radiogroup",
                        //defaultvalue: "Y",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'Y',  name: 'Invoice Every' }, { value: 'N', name: 'Invoice On' }],
                    },
                    InvoicePeriod: {
                        "type": "label",
                        "key": "InvoicePeriod",
                        "label": "Invoice Period",
                        "name": "InvoicePeriod",
                        changefieldto: "textfield",
                        "xtype" : "number"
                    },
                    InvoiceType: {
                        "type": "label",
                        "key": "InvoiceType",
                        "label": "Invoice Type",
                        "name": "InvoiceType",
                        changefieldto: "dropdown",
                        extraProps: {
                            transformProps: {
                                label: 'Name',
                                value: 'Value'
                            },
                        }
                    },
                    InvoiceOn: {
                        "type": "label",
                        "key": "InvoiceOn",
                        "label": "Invoice On",
                        "name": "InvoiceOn",
                        changefieldto: "radiogroup",
                        //defaultvalue: "E",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'E', name: 'Even Year' }, { value: 'O', name: 'Odd Year' }],
                    },
                    GenerateInvoiceOn: {
                        "type": "label",
                        "key": "GenerateInvoiceOn",
                        "label": "Generate Invoice On",
                        "name": "GenerateInvoiceOn",
                        changefieldto: "radiogroup",
                        //defaultvalue: "D",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'D', name: 'Particular Date' }, { value: 'P', name: 'Permitted Date' }],
                    },
                    GenerateInvoiceDate: {
                        "type": "label",
                        "key": "GenerateInvoiceDate",
                        "label": "Generate Invoice Date",
                        "name": "GenerateInvoiceDate",
                        changefieldto: "date",
                        // extraProps: {
                        //     dateFormat : 'MM/DD'
                        // }
                    },
                    DateOnInvoice: {
                        "type": "label",
                        "key": "DateOnInvoice",
                        "label": "Date Printed On Invoice",
                        "name": "DateOnInvoice",
                        changefieldto: "radiogroup",
                        //defaultvalue: "D",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'D', name: 'Particular Date' }, { value: 'P', name: 'Invoice Generated Date' }],
                    },
                    DateToPrintOnInvoice: {
                        "type": "label",
                        "key": "DateToPrintOnInvoice",
                        "label": "Date To Print On Invoice",
                        "name": "DateToPrintOnInvoice",
                        changefieldto: "date",
                        // extraProps: {
                        //     dateFormat : 'MM/DD'
                        // }
                    },
                    PaymentDueOnInvoice: {
                        "type": "label",
                        "key": "PaymentDueOnInvoice",
                        "label": "Payment Due On Invoice",
                        "name": "PaymentDueOnInvoice",
                        changefieldto: "radiogroup",
                        //defaultvalue: "P",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'P', name: 'Day(s) from date printed on invoice' }, { value: 'D', name: 'Particular Date' }]

                    },
                    PaymentDueDays: {
                        "type": "label",
                        "key": "PaymentDueDays",
                        "label": "Payment Due Days",
                        "name": "PaymentDueDays",
                        changefieldto: "textfield",
                        "xtype" : "number"
                    },
                    PaymentDueDate: {
                        "type": "label",
                        "key": "PaymentDueDate",
                        "label": "Payment Due Date",
                        "name": "PaymentDueDate",
                        changefieldto: "date",
                        // extraProps: {
                        //     dateFormat : 'MM/DD'
                        // }
                    },
                    Status: {
                        "type": "label",
                        "key": "Status",
                        "label": "Status",
                        "name": "Status",
                        changefieldto: "toggle",
                        extraProps: {
                            "transformProps": {
                                "A": true,
                                "I": false,
                                "true": "A",
                                "false": "I"
                            }
                        }
                    },
                    CreatedOn: {
                        "type": "label",
                        "key": "CreatedOn",
                        "label": "Created On",
                        name: "CreatedOn",
                        changefieldto: "label",
                    },
                    
                    CreatedByName: {
                        "type": "label",
                        "key": "CreatedByName",
                        "label": "Created By",
                        name: "CreatedByName",
                        changefieldto: "label",
                    },
                    UpdatedOn: {
                        "type": "label",
                        "key": "UpdatedOn",
                        "label": "Updated On",
                        name: "UpdatedOn",
                        changefieldto: "label",
                    },
                    UpdatedByName: {
                        "type": "label",
                        "key": "UpdatedByName",
                        "label": "Updated By",
                        name: "UpdatedByName",
                        changefieldto: "label",
                    },
                },
                mapActionsToEffects: {
                    'onLoad': {
                    'init': {
                        rules: [{
                            run:
                            {
                                valid: [
                                {
                                    type: 'load',
                                    name: 'InvoiceType',
                                    "read": [
                                        {
                                            url: getEnvVariable('Admin')+`/api/Domains/values?domainkey=INVOICE_TYPE`,
                                            type: 'get',
                                            saveAs: {
                                                key: 'items'
                                            }
                                        }
                                    ]
                                },
                                {
                                    type: 'businessrules',
                                    "read": [
                                        {
                                            url: getEnvVariable('Application') + `/api/BusinessRules/Grid/admin.invoicecycle`,
                                            type: 'get',
                                        }
                                    ],
                                },
                                {
                                    type: 'validations', 
                                    "read": [
                                        {
                                            "url": getEnvVariable('Admin') + `/api/ProjectMessages/RulesByName?name=admin.invoicecycle`,
                                            type: 'get'
                                        }
                                    ],
                                    transformProps: {
                                        removesubfieldname: 'LAOACSADMIN.INVOICECYCLE_'
                                    }
                                },

                                ]
                            }
                        }]
                    }},
                    'onChange': {
                    'navigation': {
                        rules: [{
                            run:
                            {
                                valid: [
                                    {
                                        type: 'initial',
                                        "read": [
                                            {
                                                url: getEnvVariable('Admin')+`/api/InvoiceCycle/{Id}`,
                                                key: 'save',
                                                "matchProps": [
                                                    {
                                                        name: "navigation.Id",
                                                        key: "Id",
                                                    }
                                                ],
                                                type: 'get',
                                            }
                                        ]
                                    },
                                ]
                            }
                        }]
                    },
                    'edit': {
                        rules: [
                            {
                                run: {
                                    valid: [
                                        {
                                            type: 'edit',

                                        },

                                    ]
                                }
                            }
                        ]
                    },
                    'createduplicate': {
                        rules: [
                            {
                                run: {
                                    valid: [
                                        {
                                            type: 'createduplicate',

                                        },

                                    ]
                                }
                            }
                        ]
                    },
                },
                'afterSave': {
                    'saveduplicate': {
                        rules: [
                            {
                                run: {
                                    valid: [
                                        {
                                            type: 'save',
                                            "read": [
                                                {
                                                    "url": getEnvVariable('Admin')+`/api/InvoiceCycle/Add`,
                                                    type: 'post',
                                                    // "matchProps": [{
                                                    //     name: "routeid1",
                                                    //     key: "routeid1",
                                                    // }]
                                                }
                                            ],
                                        },

                                    ]
                                }
                            }
                        ]
                    },

                    'save': {
                        rules: [
                            {
                                run: {
                                    valid: [
                                        {
                                            type: 'save',
                                            "read": [
                                                {
                                                    "url": getEnvVariable('Admin')+`/api/InvoiceCycle/Update`,
                                                    type: 'put',
                                                    "matchProps": [
                                                        //{
                                                    //     name: "routeid1",
                                                    //     key: "routeid1",
                                                    // },
                                                    // {
                                                    //     name: "Id",
                                                    //     key: "Id",
                                                    // }
                                                    ]
                                                }
                                            ],
                                        },

                                    ]
                                }
                            }
                        ]
                    },
                }
                }
            }
        },

    }
}

export default InvoiceCycleEdit



